module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/08797dfe44ad94864a999cb3f5db01d6.png";